import { PlusIcon, Search } from "lucide-react";
import { useRef, useState } from "react";

import { AddCity } from "./add-city/Panel";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PaginatedCitiesProps } from "./hooks/paginated-cities.hook";
import { PublishMapComponent } from "./PublishMap";

interface FiltersProps extends PaginatedCitiesProps {
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
}

export const FiltersBar = ({ setSearchValue, cityName, currentPage, setCurrentPage }: FiltersProps) => {
  const searchFieldRef = useRef<HTMLInputElement>(null);
  const [openAddCityModal, setOpenAddCityModal] = useState<boolean>(false);

  return (
    <>
      <div className="flex flex-row gap-x-2 items-center justify-between w-full">
        <div className="relative w-2/6">
          <Input
            ref={searchFieldRef}
            className="pl-9"
            placeholder="Recherche par nom de ville..."
            onChange={(e) => {
              const cityName = e.target.value;
              const pageIndex = 1;
              if (cityName.length >= 3 || cityName.length === 0) {
                setSearchValue(cityName);
                setCurrentPage({ ...currentPage, pageIndex });
              }
            }}
          />
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        </div>
        <div className="ml-auto flex gap-x-2">
          <PublishMapComponent />
          <Button onClick={() => setOpenAddCityModal(true)} className="gap-x-1" variant="outline">
            Add city
            <PlusIcon className="h-4 w-4" />
          </Button>
        </div>
      </div>
      {openAddCityModal && (
        <AddCity
          open={openAddCityModal}
          onDismiss={setOpenAddCityModal}
          {...{ cityName, setCurrentPage, currentPage }}
        />
      )}
    </>
  );
};
